import { render, staticRenderFns } from "./verifyResetToken.vue?vue&type=template&id=1136e640&"
import script from "./verifyResetToken.vue?vue&type=script&lang=js&"
export * from "./verifyResetToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports